import React from 'react';
import icon from './images/app_logo.png';
import logo from '../../assets/images/lookmysaloon-removebg-preview.png';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <div className="logo">
                            <img src={logo} alt="My Salon Hub Logo" style={{height:'80px'}}/>
                            {/* <img src={logo} alt="My Salon Hub Logo" style={{ height: '30px' }} /> */}
                            {/* <span className="logo-text">My<span>SalonHub</span></span> */}
                        </div>
                        <p>The beauty of simplicity, crafted for salons. India's smartest salon platform connecting vendors
                            and clients seamlessly.</p>
                    </div>
                    <div className="footer-col">
                        <h5>Platform</h5>
                        <a href="#vendor">Vendor App</a>
                        <a href="#">Pricing</a>
                    </div>
                    <div className="footer-col">
                        <h5>Resources</h5>
                        <a href="#">Help Center</a>
                        <a href="#">Blog</a>
                        <a href="#">Contact Support</a>
                    </div>
                    <div className="footer-col">
                        <h5>Legal</h5>
                        <a href='/privacy-policy' target="_blank">Privacy Policy</a>
                        <a href='/terms-and-conditions' target="_blank">Terms & Conditions</a>
                        <a href='/return-and-refund-policy' target="_blank">Return & Refund Policy</a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2026 My Salon Hub Platform. All rights reserved.</p>
                    <p className="footer-made">Made with <span>♥</span> for Indian Salons</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
